var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 985,
    height: 735,
    viewBox: "0 0 985 735",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-214.828 571.804C-240.446 452.161 -222.773 321.256 -155.404 217.887C-49.4679 55.3685 222.92 -14.7449 397.602 64.6399C458.193 92.1721 501.87 138.305 530.069 197.836C560.233 261.552 563.757 338.616 607.329 396.099C644.752 445.449 709.514 464.512 745.16 515.036C787.721 575.366 797.342 663.914 757.2 727.986C705.789 810.053 590.138 867.361 502.568 900.775C235.109 1002.84 -97.7308 920.711 -199.267 627.751C-205.603 609.466 -210.802 590.771 -214.857 571.854L-214.828 571.804Z",
    fill: "#E2F1E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.37404e-05 651H353.884C353.884 651 409.079 637.324 423.779 632.759C438.499 628.194 458.727 629.107 466.097 630.933C473.447 632.759 494.616 634.585 494.616 634.585L524.056 620.909L536.013 610.885L555.319 589.925L571.882 564.399L588.444 553.462L611.436 544.352L670.296 517H741.113L767.789 517.913L788.938 537.047L827.571 560.747C827.571 560.747 831.256 599.949 834 602.688",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M350.169 525.676C350.169 525.676 338.868 434.032 384.075 400.156C429.253 366.25 618.807 231.946 618.807 231.946L653.227 195.008C654.801 189.8 650.681 184.65 645.245 184.994L593.686 203.076C593.686 203.076 368.996 312.288 338.868 337.381C308.739 362.474 294.92 410.198 292.43 440.327C289.913 470.455 289.913 529.453 289.913 529.453L350.169 525.676Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M822.983 240.616L701.639 152.863",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M841.437 280.958L927.416 283.905C933.024 284.106 937.459 288.684 937.459 294.291C937.459 299.899 933.339 304.048 928.217 304.62L920.32 360.585C922.438 362.502 923.783 365.221 923.783 368.282C923.783 374.548 918.289 379.383 912.08 378.582L874.055 374.977C870.679 374.548 868.218 371.544 868.476 368.139C868.733 364.706 871.652 362.073 875.085 362.188L901.322 359.269L914.369 303.161L840.436 293.776C837.06 293.347 834.599 290.343 834.857 286.938C835.114 283.505 838.032 280.872 841.466 280.987L841.437 280.958Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M905.013 300.986L822.983 240.615",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M660.238 129L714.2 150.345L702.898 165.423L660.238 129Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M715.03 333.175L736.947 337.295L769.136 335.235L775.888 341.987L841.753 317.438H887.646C887.646 317.438 895.171 323.59 897.231 331.83C899.292 340.042 894.485 350.313 891.738 366.079C888.991 381.844 895.171 397.58 890.365 413.346C886.702 425.42 874.971 444.676 850.022 447.508L849.965 447.594H849.392C845.759 447.966 841.867 447.995 837.661 447.594H801.324V437.322H805.845C772.397 417.752 752.226 375.492 749.279 370.199L742.441 370.885L669.137 333.203H715.03V333.175Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M898.318 338.096L612.513 201.817L592.856 142.877C591.369 138.385 594.487 133.692 599.208 133.349L660.18 129L907.531 322.674C910.936 325.421 911.88 330.228 909.791 334.062C907.559 338.125 902.638 339.87 898.346 338.096H898.318Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M589.938 141.56C589.938 136.009 594.43 131.517 599.981 131.517C605.532 131.517 610.024 136.009 610.024 141.56C610.024 147.111 605.532 151.603 599.981 151.603C594.43 151.603 589.938 147.111 589.938 141.56Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M917.86 294.721L907.388 368.969H887.302L904.756 293.834L917.86 294.721Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M829.706 280.958L915.685 283.905C921.293 284.105 925.728 288.683 925.728 294.291C925.728 300.557 920.235 305.392 914.026 304.591L828.676 293.747C825.3 293.318 822.839 290.314 823.097 286.909C823.354 283.476 826.273 280.843 829.706 280.958Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M863.326 362.159L902.009 357.839C907.617 358.039 912.052 362.617 912.052 368.225C912.052 374.491 906.558 379.326 900.349 378.525L862.324 374.92C858.948 374.491 856.487 371.486 856.745 368.082C857.002 364.648 859.921 362.016 863.354 362.13L863.326 362.159Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M899.978 372.201L863.64 317.123C860.064 312.803 860.579 306.451 864.756 302.732C869.449 298.583 876.716 299.47 880.235 304.649L910.221 364.505C912.138 367.309 911.537 371.143 908.819 373.231C906.072 375.32 902.181 374.891 899.978 372.23V372.201Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M841.752 317.41C841.752 317.41 849.277 323.562 851.337 331.802C853.397 340.013 848.59 350.285 845.843 366.05C843.096 381.816 849.277 397.552 844.47 413.317C839.663 429.083 821.18 457.151 777.346 444.819C733.513 432.487 706.789 376.322 703.384 370.17L696.546 370.857L669.136 333.175L691.052 337.295L723.241 335.235L735.573 347.567L841.752 317.439V317.41Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M541.212 190.773L406.65 303.475",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M599.981 141.56L541.212 190.773",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M367.623 423.531L358.21 550.139",
    stroke: "#263238",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M374.347 347.166L367.623 423.531",
    stroke: "#263238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M332.602 525.676C332.602 525.676 321.301 434.032 366.507 400.156C411.686 366.25 601.24 231.946 601.24 231.946L635.66 195.008C637.234 189.8 633.114 184.65 627.678 184.994L576.119 203.076C576.119 203.076 351.429 312.288 321.301 337.381C291.172 362.474 277.353 410.198 274.863 440.327C272.345 470.455 272.345 529.453 272.345 529.453L332.602 525.676Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M339.869 468.052C341.843 467.737 343.417 466.106 343.588 464.018L353.202 343.332C353.402 340.9 351.571 338.754 349.139 338.554C346.707 338.354 344.561 340.185 344.361 342.617L334.747 463.302C334.547 465.734 336.378 467.88 338.81 468.08C339.154 468.109 339.526 468.08 339.84 468.052H339.869Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M342.215 344.992C341.643 341.272 344.161 337.781 347.881 337.209C351.6 336.637 355.091 339.155 355.663 342.874C356.235 346.594 353.717 350.085 349.998 350.657C346.278 351.229 342.788 348.711 342.215 344.992Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M196.495 559.381H341.987V575.318H196.495V559.381Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M136.839 580.325H204.592V651.082H136.839V580.325Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M204.678 574.86H333.775V587.792H204.678V574.86Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.874 584.731H316.608V601.784H221.874V584.731Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M174.95 600.925H363.531V617.52H174.95V600.925Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.638 462.729C156.638 472.086 164.221 479.668 173.577 479.668C182.933 479.668 190.515 472.086 190.515 462.729C190.515 453.373 182.933 445.791 173.577 445.791C164.221 445.791 156.638 453.373 156.638 462.729Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9658 483.674L73.3777 468.138C76.1817 462.987 81.5607 459.754 87.4262 459.754H155.637L177.554 482.672L64.9658 483.674Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M316.064 476.692H63.1055C55.3231 476.692 48.9998 483.016 48.9998 490.798V563.387H316.035V476.692H316.064Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M254.406 411.858H353.775C360.699 440.613 365.535 479.239 368.653 534.546L369.454 550.14H316.007V515.491C305.221 507.966 293.69 501.728 283.475 500.154C253.261 495.519 246.28 478.066 246.28 478.066L254.406 411.829V411.858Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M315.435 411.858C322.989 443.245 328.082 486.335 331.115 550.139H308.54C308.54 550.139 293.261 526.62 245.136 515.204C215.408 508.137 201.588 485.934 201.588 485.934L216.095 411.858H315.464H315.435Z",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M360.642 508.91H336.379C336.379 508.91 331.715 451.142 323.79 420.842H348.968C348.968 420.842 358.868 471.17 360.642 508.91Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M250.256 492.744L257.982 420.842H311.086C313.203 433.403 319.125 469.54 320.699 492.744H250.256Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M218.097 492.744L226.738 420.842H246.509L238.726 492.744H218.097Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M370.885 523.53H396.779V563.387H370.885V523.53Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0289 550.139H369.454V563.358H49.0289V550.139Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M330.027 550.139H369.454V563.358H330.027V550.139Z",
    fill: "#009252",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M198.497 495.605V547.421",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M144.68 483.674V548.423",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9658 483.674V549.424",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M142.705 514.546H52.0048",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M418.925 580.325H356.923V651.082H418.925C422.101 651.082 424.676 648.507 424.676 645.331V586.104C424.676 582.929 422.101 580.353 418.925 580.353V580.325Z",
    fill: "#C4C4C4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M424.39 593.258H357.667",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M424.39 605.933H357.667",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M424.39 618.579H357.667",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M424.39 631.255H357.667",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M424.39 640.582H357.667",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M424.39 646.591H357.667",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M424.39 585.933H357.667",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M180.874 580.325H120.846C116.582 580.325 113.12 583.787 113.12 588.05V643.471C113.12 647.677 116.525 651.082 120.731 651.082H180.874V580.325Z",
    fill: "#C4C4C4",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M180.587 593.258H113.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M180.587 605.933H113.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M180.587 618.579H113.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M180.587 631.255H113.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M180.587 640.582H113.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M180.587 646.591H113.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M180.587 585.933H113.864",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M135.38 487.708H78.7853",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M135.38 493.373H78.7853",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M135.38 499.038H78.7853",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M135.38 504.704H78.7853",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.ed3a77d3daff1ccfd2863bec0a9d078a.svg";
export { ForwardRef as ReactComponent };